import { isBwBioscopeVersion, isColorBioscopeVersion } from '@/utils/bioscopeVersionHelpers';

export function isOverviewBwPen(cage: {
    activeBioscopes: number[];
    bioscopeVersion?: string;
}): boolean {
    return cage.activeBioscopes.length > 0 && isBwBioscopeVersion(cage.bioscopeVersion);
}

export function isOverviewColorPen(cage: {
    activeBioscopes: number[];
    bioscopeVersion?: string;
}): boolean {
    return cage.activeBioscopes.length > 0 && isColorBioscopeVersion(cage.bioscopeVersion);
}

export interface OverviewHealthColumnVisibility {
    showBetaLaksvelColumn: boolean;
    showWoundColumn: boolean;
}

export function getOverviewHealthColumnVisibility(params: {
    isHealthModuleEnabled: boolean;
    hasAccessToLaksvel: boolean;
    hasAccessToFishHealth: boolean;
    /**
     * Whether ANY pen in the table is a species wounds are scored for. A location can hold
     * several species (WB-2207), so the column follows the pens rather than the site default,
     * and it comes from `speciesTraits` rather than a comparison. Cells are gated per pen the
     * same way.
     */
    hasWoundScoringPen: boolean;
    hasBwPen: boolean;
    hasColorPen: boolean;
}): OverviewHealthColumnVisibility {
    const {
        isHealthModuleEnabled,
        hasAccessToLaksvel,
        hasAccessToFishHealth,
        hasWoundScoringPen,
        hasBwPen,
        hasColorPen,
    } = params;

    const showBetaLaksvelColumn = isHealthModuleEnabled && hasAccessToLaksvel && hasColorPen;

    const showWoundColumn =
        hasAccessToFishHealth &&
        hasWoundScoringPen &&
        (hasBwPen || (isHealthModuleEnabled && hasColorPen));

    return {
        showBetaLaksvelColumn,
        showWoundColumn,
    };
}

export function shouldShowBetaLaksvelOverviewCell(
    isHealthModuleEnabled: boolean,
    bioscopeVersion?: string
): boolean {
    return isHealthModuleEnabled && isColorBioscopeVersion(bioscopeVersion);
}

/** Legacy wound cells are gated by bioscope 1.0 only; health module flag is ignored. */
export function shouldShowLegacyWoundOverviewCell(
    _isHealthModuleEnabled: boolean,
    bioscopeVersion?: string
): boolean {
    return isBwBioscopeVersion(bioscopeVersion);
}

export function shouldShowBetaWoundOverviewCell(
    isHealthModuleEnabled: boolean,
    bioscopeVersion?: string
): boolean {
    return isHealthModuleEnabled && isColorBioscopeVersion(bioscopeVersion);
}
